'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Close = function Close(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutProperties(_ref, ['fill']);

  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      'svg',
      { style: { display: 'block' }, xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', x: '0px', y: '0px', width: '100%', height: '100%', viewBox: '0 0 16 16' },
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { fill: fill, d: 'M14.7,1.3c-0.4-0.4-1-0.4-1.4,0L8,6.6L2.7,1.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L6.6,8l-5.3,5.3c-0.4,0.4-0.4,1,0,1.4C1.5,14.9,1.7,15,2,15s0.5-0.1,0.7-0.3L8,9.4l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L9.4,8l5.3-5.3C15.1,2.3,15.1,1.7,14.7,1.3z' })
      )
    )
  );
};

Close.propTypes = _extends({}, _Icon2.default.propTypes);

Close.defaultProps = _extends({}, _Icon2.default.defaultProps);

exports.default = Close;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0Nsb3NlLmpzIl0sIm5hbWVzIjpbIkNsb3NlIiwiZmlsbCIsInByb3BzIiwiZGlzcGxheSIsInByb3BUeXBlcyIsImRlZmF1bHRQcm9wcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7Ozs7OztBQUVBLElBQU1BLFFBQVEsU0FBUkEsS0FBUSxPQUF3QjtBQUFBLE1BQXJCQyxJQUFxQixRQUFyQkEsSUFBcUI7QUFBQSxNQUFaQyxLQUFZOztBQUNwQyxTQUNFO0FBQUE7QUFBVUEsU0FBVjtBQUNFO0FBQUE7QUFBQSxRQUFLLE9BQU8sRUFBRUMsU0FBUyxPQUFYLEVBQVosRUFBa0MsT0FBTSw0QkFBeEMsRUFBcUUsWUFBVyw4QkFBaEYsRUFBK0csR0FBRSxLQUFqSCxFQUF1SCxHQUFFLEtBQXpILEVBQStILE9BQU0sTUFBckksRUFBNEksUUFBTyxNQUFuSixFQUEwSixTQUFRLFdBQWxLO0FBQ0U7QUFBQTtBQUFBO0FBQ0UsZ0RBQU0sTUFBTUYsSUFBWixFQUFrQixHQUFFLDZRQUFwQjtBQURGO0FBREY7QUFERixHQURGO0FBU0QsQ0FWRDs7QUFZQUQsTUFBTUksU0FBTixnQkFDSyxlQUFLQSxTQURWOztBQUlBSixNQUFNSyxZQUFOLGdCQUNLLGVBQUtBLFlBRFY7O2tCQUllTCxLIiwiZmlsZSI6IkNsb3NlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IEljb24gZnJvbSAnLi9JY29uJ1xuXG5jb25zdCBDbG9zZSA9ICh7IGZpbGwsIC4uLnByb3BzIH0pID0+IHtcbiAgcmV0dXJuIChcbiAgICA8SWNvbiB7Li4ucHJvcHN9PlxuICAgICAgPHN2ZyBzdHlsZT17eyBkaXNwbGF5OiAnYmxvY2snIH19IHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZycgeG1sbnNYbGluaz0naHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluaycgeD0nMHB4JyB5PScwcHgnIHdpZHRoPScxMDAlJyBoZWlnaHQ9JzEwMCUnIHZpZXdCb3g9JzAgMCAxNiAxNic+XG4gICAgICAgIDxnPlxuICAgICAgICAgIDxwYXRoIGZpbGw9e2ZpbGx9IGQ9J00xNC43LDEuM2MtMC40LTAuNC0xLTAuNC0xLjQsMEw4LDYuNkwyLjcsMS4zYy0wLjQtMC40LTEtMC40LTEuNCwwcy0wLjQsMSwwLDEuNEw2LjYsOGwtNS4zLDUuM2MtMC40LDAuNC0wLjQsMSwwLDEuNEMxLjUsMTQuOSwxLjcsMTUsMiwxNXMwLjUtMC4xLDAuNy0wLjNMOCw5LjRsNS4zLDUuM2MwLjIsMC4yLDAuNSwwLjMsMC43LDAuM3MwLjUtMC4xLDAuNy0wLjNjMC40LTAuNCwwLjQtMSwwLTEuNEw5LjQsOGw1LjMtNS4zQzE1LjEsMi4zLDE1LjEsMS43LDE0LjcsMS4zeicgLz5cbiAgICAgICAgPC9nPlxuICAgICAgPC9zdmc+XG4gICAgPC9JY29uPlxuICApXG59XG5cbkNsb3NlLnByb3BUeXBlcyA9IHtcbiAgLi4uSWNvbi5wcm9wVHlwZXNcbn1cblxuQ2xvc2UuZGVmYXVsdFByb3BzID0ge1xuICAuLi5JY29uLmRlZmF1bHRQcm9wc1xufVxuXG5leHBvcnQgZGVmYXVsdCBDbG9zZVxuIl19


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Close.js
// module id = 390
// module chunks = 0